import React from 'react'
import { WarningFilled } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { Texto } from '@gravitate-js/excalibrr'
import moment from 'moment'
import { SingleError } from './SingleError'
import { formatters } from '@utils/intl/dateTimeFormatters'

export const BypassDisplay = ({ order }) => {
  const timezone = order?.bol_date_local || order?.delivery_date_local
  return (
    <div className='bg-3 p-3 px-4 flex items-center '>
      <WarningFilled className='mr-5' />
      <div className='vertical-flex-center mr-5'>
        <Texto category='h5' weight='bold' className='mr-4'>
          Errors Bypassed
        </Texto>
        <Texto>On {formatters.DATE_TIME(moment(order.validation_bypass_on), timezone, true)}</Texto>
      </div>
      <div className='vertical-flex-center mx-5' style={{ whiteSpace: 'initial' }}>
        <Texto category='h6' weight='bold' className='mr-4'>
          {order.validation_bypass_reason}
          {order.validation_bypass_note && (
            <Tooltip title={order.validation_bypass_note}>
              <a className='ml-3'>View Note</a>
            </Tooltip>
          )}
        </Texto>
        <Texto>
          Bypassed by <b>{order.validation_bypass_by}</b>
        </Texto>
      </div>

      <div className='flex-1 flex items-center' style={{ whiteSpace: 'initial' }}>
        {order.movement_validation_issues.map((e, i) => (
          <>
            <SingleError isBypassed error={e} key={i} />
            {i !== order.movement_validation_issues.length - 1 && (
              <div
                className='mx-3 flex justify-center'
                style={{ width: 1, height: 12, background: 'var(--gray-500)' }}
              />
            )}
          </>
        ))}
      </div>
    </div>
  )
}
